import React from 'react';
import { Box, Container, Typography, Button, Grid, Link } from '@mui/material';
import { useStyles } from './styles';
import NextLink from 'next/link';
import { useRouter } from 'next/router';

const infoArticles = [
  {
    image: '/images/success-cases/image-articles/article1.png',
    description:
      'Modeling of inhomogeneous electromagnetic fields in the nervous system: a novel paradigm in understanding cell interactions, disease etiology and therapy.',
    info: 'High Altmetric Attention Score than 82% of outputs of the same age and source.',
    logo: '/images/success-cases/logo-image/nature.png',
    url: 'https://mindthegraph.com/blog/success-case-modeling-of-inhomogeneous-electromagnetic-fields-in-the-nervous-system',
  },
  {
    image: '/images/success-cases/image-articles/article4.png',
    description:
      'Immunotherapeutic potential of Crotoxin: anti-inflammatory and immunosuppressive properties.',
    info: '4,709 Article accesses and 14 citations.',
    logo: '/images/success-cases/logo-image/bmc.png',
    url: 'https://mindthegraph.com/blog/success-case-immunotherapeutic-potential-of-Crotoxin-anti-inflammatory-and-immunosuppressive-properties',
  },
  {
    image: '/images/success-cases/image-articles/article3.png',
    description:
      'High-resolution synchrotron-based X-ray microtomography as a tool to unveil the three-dimensional neuronal architecture of the brain.',
    info: 'Above-average Altmetric Attention Score compared to outputs of the same age.',
    logo: '/images/success-cases/logo-image/nature.png',
    url: 'https://mindthegraph.com/blog/success-case-igh-resolution-synchrotron-based-x-ray-microtomography-as-a-tool-to-unveil-the-three-dimensional-neuronal-architecture-of-the-brain',
  },
  {
    image: '/images/success-cases/image-articles/article2.png',
    description: 'FGF Signalling in the Self-Renewal of Colon Cancer Organoids.',
    info: 'Higher Altmetric Attention Score than 75% of all research outputs.',
    logo: '/images/success-cases/logo-image/nature.png',
    url: 'https://mindthegraph.com/blog/success-case-fgf-signalling-in-the-self-renewal-of-colon-cancer-organoids',
  },
  {
    image: '/images/success-cases/image-articles/article6.png',
    description: 'XTALKDB: a database of signaling pathway crosstalk.',
    info: '1.63x more citations than average publications in the same field.',
    logo: '/images/success-cases/logo-image/oxford.png',
    url: 'https://mindthegraph.com/blog/success-case-XTALKDB-a-database-of-signaling-pathway-crosstalk',
  },
  {
    image: '/images/success-cases/image-articles/article5.png',
    description: 'Nuclear receptors in liver fibrosis.',
    info: 'Higher citations than 57% of all Elsevier articles in the same year.',
    altText: 'Top science journal',
    url: 'https://mindthegraph.com/blog/success-case-nuclear-receptors-in-liver-fibrosis',
  },
  {
    image: '/images/success-cases/image-articles/article8.png',
    description:
      'Psychedelic-Assisted Psychotherapy: A Paradigm Shift in Psychiatric Research and Development.',
    info: 'HMore views than 99% of all Frontiers articles.',
    logo: '/images/success-cases/logo-image/frontiers.png',
    url: 'https://mindthegraph.com/blog/success-case-psychedelic-assisted-psychotherapy/',
  },
  {
    image: '/images/success-cases/image-articles/article9.png',
    description:
      'Zika virus replicates in adult human brain tissue and impairs synapses and memory in mice.',
    info: 'In the top 5% of all research outputs scored by Altmetric.',
    logo: '/images/success-cases/logo-image/nature.png',
    url: 'https://mindthegraph.com/blog/success-case-zika-virus-replicates-in-adult-human-brain-tissue-and-impairs-synapses-and-memory-in-mice/',
  },
  {
    image: '/images/success-cases/image-articles/article10.png',
    description:
      'NMDA receptor adjusted co-administration of ecstasy and cannabinoid receptor-1 agonist in the amygdala via stimulation of BDNF/Trk-B/CREB pathway in adult male rats.',
    info: 'Higher citations than 47% of all Elsevier articles in the same year.',
    altText: 'Top science journal',
    url: 'https://mindthegraph.com/blog/success-case-NMDA-receptor-adjusted-co-administration-of-ecstasy-and-cannabinoid-receptor-1-agonist',
  },
];

export default function MainContent() {
  const classes = useStyles();
  const router = useRouter();

  return (
    <>
      <Box py={8} bgcolor="#eee">
        <Container>
          <Box mb={7}>
            <Typography className={classes.primaryColor} variant="h2" align="center">
              <b>
                These articles are using Mind the Graph to create beautiful infographics as a way of
                getting more citations and being remembered by many people.
              </b>
            </Typography>
          </Box>

          <Grid container={true} spacing={5}>
            {infoArticles.map((prop) => (
              <Grid item={true} xs={12} sm={6} md={4} key={prop.description}>
                <Link href={prop.url} target="_blank" underline="hover">
                  <img className={classes.image} src={prop.image} alt="image" />
                </Link>

                <Box pb={4} px={2}>
                  <Typography className={classes.textDescription}>
                    <b>{prop.description}</b>
                  </Typography>

                  <Typography className={classes.textInfo}>{prop.info}</Typography>

                  <hr className={classes.divider} />

                  <Typography className={classes.publishedIn}>
                    <b>Published in:</b>
                  </Typography>

                  <div className={classes.ctaLogo}>
                    {prop.logo ? (
                      <img src={prop.logo} alt="logo image" />
                    ) : (
                      <Typography variant="body1">
                        <b>{prop.altText}</b>
                      </Typography>
                    )}
                    <Button className={classes.btnSeeMore} target="_blank" href={prop.url}>
                      See more
                    </Button>
                  </div>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>

      <Box py={6} bgcolor="common.white">
        <Container>
          <Box py={3}>
            <Typography className={classes.primaryColor} variant="h2" align="center">
              <b>Articles with infographics have</b>
            </Typography>
          </Box>

          <Box display="flex" justifyContent="center" flexWrap="wrap">
            <Box px={6}>
              <Typography className={classes.textNumber}>
                <b>3x</b>
              </Typography>
              <Typography className={classes.textMore}>more downloads</Typography>
            </Box>

            <Box px={6}>
              <Typography className={classes.textNumber}>
                <b>15x</b>
              </Typography>
              <Typography className={classes.textMore}>more citations</Typography>
            </Box>

            <Box px={6}>
              <Typography className={classes.textNumber}>
                <b>8x</b>
              </Typography>
              <Typography className={classes.textMore}>
                more shares on <br /> social media
              </Typography>
            </Box>

            <Box px={6}>
              <Typography className={classes.textNumber}>
                <b>4.8x</b>
              </Typography>
              <Typography className={classes.textMore}>more retweets</Typography>
            </Box>
          </Box>

          <Box py={8}>
            <hr className={classes.dividerTrusted} />
          </Box>

          <Typography className={classes.primaryColor} variant="h2" align="center">
            <b>Trusted By</b>
          </Typography>

          <div className={classes.logoWrapper}>
            <img src="/images/stanford-logo.png" alt="Stanford logo" />
            <img src="/images/ucla-logo.png" alt="UCLA logo" />
            <img src="/images/pearson-logo.png" alt="Pearson logo" />
            <img src="/images/harvard-logo.png" alt="Harvard logo" />
            <img src="/images/abbott-logo.png" alt="Abbott logo" />
            <img src="/images/mcgill-logo.png" alt="Mcgill logo" />
          </div>
        </Container>
      </Box>

      <Box py={8} bgcolor="#7833FF">
        <Typography className={classes.textCreating}>
          <b>
            Start creating now and innovate on your <br /> research with science illustrations.
          </b>
        </Typography>

        <Box p={3} display="flex" justifyContent="center">
          <NextLink
            href={`/auth/login-register?from_url=${router.basePath + router.asPath}`}
            passHref={true}
          >
            <Button className={classes.btnCreating} color="primary" variant="contained">
              <b>Start creating now</b>
            </Button>
          </NextLink>
        </Box>
      </Box>
    </>
  );
}
